module.exports = "/_next/static/images/f924d1832f00179dc1874110af5a14df-sarlaft-lg.png.webp";